export default "__VITE_ASSET__DVqaYLvW__"